import React from 'react'
import PropTypes from 'prop-types'
import { Message } from 'mage-i18n'
import { TitleSecondary, LinkPrimary, SpacerVertical } from '@klarna/bubble-ui'
import { useHelpContext, useFilterArticlesByExperiment } from '../hooks'

RelatedContent.propTypes = {
  title: PropTypes.string.isRequired,
  articles: PropTypes.arrayOf(PropTypes.object.isRequired),
  analyticsCategory: PropTypes.string.isRequired
}

const getNavigationHandler = (navigation, article) => event => {
  event.preventDefault()
  navigation.push('article', { articleSlug: article.slug })
}

export default function RelatedContent ({ articles, title, analyticsCategory }) {
  const { navigation } = useHelpContext()

  const activeArticles = useFilterArticlesByExperiment(articles)

  if (!activeArticles) return null

  const visibleArticles = activeArticles.filter(article => !article.hidden)

  if (!visibleArticles || !visibleArticles.length) return null

  const slicedArticles = visibleArticles.slice(0, 4)

  return (
    <div>
      <SpacerVertical small />

      <TitleSecondary>
        <Message path={title} />
      </TitleSecondary>

      {slicedArticles.map(article => (
        <div key={article.id}>
          <SpacerVertical extraSmall />

          <LinkPrimary onClick={getNavigationHandler(navigation, article)}>
            {article.title}
          </LinkPrimary>
        </div>
      ))}

      <SpacerVertical small />
    </div>
  )
}
